/// <reference types="@types/googlemaps" />

import { Directive, ElementRef, OnInit, Input, NgZone } from '@angular/core';
//import { } from '@types/googlemaps';

import { HomeComponent } from '../home/home.component'

@Directive({
  selector: '[google-places]'
})
export class GooglePlacesDirective implements OnInit {
  private element: HTMLInputElement;

  streetNumber: string;
  address: string;

  constructor(private elRef: ElementRef, private ngZone: NgZone, public homeComponent: HomeComponent) {
    this.element = elRef.nativeElement;
  }

  ngOnInit() {
    const autocomplete = new google.maps.places.Autocomplete(this.element);

    autocomplete.addListener("place_changed", () => {
      this.ngZone.run(() => {
        let place: google.maps.places.PlaceResult = autocomplete.getPlace();

        if (place.geometry === undefined || place.geometry === null) {
          return;
        }

        this.homeComponent.lat = place.geometry.location.lat();
        this.homeComponent.lng = place.geometry.location.lng();

        this.homeComponent.place = place.formatted_address;

        for (let places of place.address_components) {
          if (places.types[0] == 'street_number') {
            this.streetNumber = places.long_name
          }

          if (places.types[0] == 'route') {
            this.address = places.long_name
          }

          if (places.types[0] == 'administrative_area_level_3' || places.types[0] == 'locality') {
            this.homeComponent.Facility.City = places.long_name
          }
        }

        if (this.streetNumber == undefined && this.address == undefined) {
          this.homeComponent.Facility.Address = '';
        }
        if (this.streetNumber == undefined && this.address != undefined) {
          this.homeComponent.Facility.Address = this.address;
        }

        if (this.streetNumber != undefined && this.address != undefined) {
          this.homeComponent.Facility.Address = this.address + ' ' + this.streetNumber;
        }

      })
    })
  }
}
